import Layout from './index.vue'

export default Layout
